import { StyledSectionHeading } from "../styles/common/SectionHeading.style";
import {
  StyledSingleSkill,
  StyledSkillsItems,
  StyledSkillsSection,
} from "../styles/sections/SkillsSection.styled";

import {
  SiAngular,
  SiDocker,
  SiExpress,
  SiGithubactions,
  SiGrafana,
  SiLinux,
  SiMongodb,
  SiNginx,
  SiNuxtdotjs,
  SiPostgresql,
  SiPrometheus,
  SiReact,
  SiTypescript,
  SiVuedotjs,
} from "react-icons/si";
// Playwright et Vitest n'ont pas de logo dans react-icons 4.7.1 : glyphes neutres.
import { TbFlask, TbTestPipe } from "react-icons/tb";

import { useTranslation } from "react-i18next";
export const SkillsSection = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledSkillsSection id="skills">
        <StyledSectionHeading>
          <h1 data-aos="flip-right">{t("HeaderSkill")}</h1>
        </StyledSectionHeading>
        <StyledSkillsItems>
          <StyledSingleSkill data-aos="fade-right" data-aos-offset="0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 32 32"
            >
              <g>
                <path fill="#E44D26" d="M6 28L4 3h24l-2 25-10 3-10-3z"></path>
                <path fill="#F16529" d="M26 5H16v24.5l8-2.5 2-22z"></path>
                <path
                  fill="#fff"
                  d="M9.5 17.5L8.5 8H24l-.5 3h-12l.5 3.5h11L22 24l-6 2-6-2-.5-5h3l.5 2.5 3 1 3-1 .5-4h-10z"
                ></path>
              </g>
            </svg>
            <h2>HTML</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <svg
              width="100px"
              height="100px"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 28L4 3H28L26 28L16 31L6 28Z" fill="#1172B8" />
              <path d="M26 5H16V29.5L24 27L26 5Z" fill="#33AADD" />
              <path
                d="M19.5 17.5H9.5L9 14L17 11.5H9L8.5 8.5H24L23.5 12L17 14.5H23L22 24L16 26L10 24L9.5 19H12.5L13 21.5L16 22.5L19 21.5L19.5 17.5Z"
                fill="white"
              />
            </svg>
            <h2>CSS</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <svg
              width="800px"
              height="800px"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="2" y="2" width="28" height="28" fill="#FFCA28" />
              <path
                d="M19 25.2879L21.0615 23.9237C21.2231 24.4313 22.2462 25.6368 23.5385 25.6368C24.8308 25.6368 25.4308 24.931 25.4308 24.463C25.4308 23.1878 24.1112 22.7382 23.4774 22.5223C23.374 22.4871 23.289 22.4581 23.2308 22.4328C23.2009 22.4198 23.1558 22.4025 23.0979 22.3804C22.393 22.1111 19.7923 21.1175 19.7923 18.2373C19.7923 15.065 22.8538 14.7002 23.5462 14.7002C23.9991 14.7002 26.1769 14.7557 27.2615 16.7939L25.2615 18.1898C24.8231 17.3015 24.0946 17.0081 23.6462 17.0081C22.5385 17.0081 22.3077 17.8201 22.3077 18.1898C22.3077 19.227 23.5112 19.6919 24.5273 20.0844C24.7932 20.1871 25.0462 20.2848 25.2615 20.3866C26.3692 20.91 28 21.7666 28 24.463C28 25.8136 26.8672 28.0002 24.0154 28.0002C20.1846 28.0002 19.1692 25.7003 19 25.2879Z"
                fill="#3E3E3E"
              />
              <path
                d="M9 25.5587L11.1487 24.1953C11.317 24.7026 11.9713 25.638 12.9205 25.638C13.8698 25.638 14.3557 24.663 14.3557 24.1953V15.0002H16.9982V24.1953C17.041 25.4636 16.3376 28.0002 13.2332 28.0002C10.379 28.0002 9.19242 26.3039 9 25.5587Z"
                fill="#3E3E3E"
              />
            </svg>
            <h2>JS</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <svg
              width="800px"
              height="800px"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6789 15.9759C18.6789 14.5415 17.4796 13.3785 16 13.3785C14.5206 13.3785 13.3211 14.5415 13.3211 15.9759C13.3211 17.4105 14.5206 18.5734 16 18.5734C17.4796 18.5734 18.6789 17.4105 18.6789 15.9759Z"
                fill="#53C1DE"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7004 11.1537C25.2661 8.92478 25.9772 4.79148 23.4704 3.39016C20.9753 1.99495 17.7284 4.66843 16.0139 6.27318C14.3044 4.68442 10.9663 2.02237 8.46163 3.42814C5.96751 4.82803 6.73664 8.8928 7.3149 11.1357C4.98831 11.7764 1 13.1564 1 15.9759C1 18.7874 4.98416 20.2888 7.29698 20.9289C6.71658 23.1842 5.98596 27.1909 8.48327 28.5877C10.9973 29.9932 14.325 27.3945 16.0554 25.7722C17.7809 27.3864 20.9966 30.0021 23.4922 28.6014C25.9956 27.1963 25.3436 23.1184 24.7653 20.8625C27.0073 20.221 31 18.7523 31 15.9759C31 13.1835 26.9903 11.7923 24.7004 11.1537ZM24.4162 19.667C24.0365 18.5016 23.524 17.2623 22.8971 15.9821C23.4955 14.7321 23.9881 13.5088 24.3572 12.3509C26.0359 12.8228 29.7185 13.9013 29.7185 15.9759C29.7185 18.07 26.1846 19.1587 24.4162 19.667ZM22.85 27.526C20.988 28.571 18.2221 26.0696 16.9478 24.8809C17.7932 23.9844 18.638 22.9422 19.4625 21.7849C20.9129 21.6602 22.283 21.4562 23.5256 21.1777C23.9326 22.7734 24.7202 26.4763 22.85 27.526ZM9.12362 27.5111C7.26143 26.47 8.11258 22.8946 8.53957 21.2333C9.76834 21.4969 11.1286 21.6865 12.5824 21.8008C13.4123 22.9332 14.2816 23.9741 15.1576 24.8857C14.0753 25.9008 10.9945 28.557 9.12362 27.5111ZM2.28149 15.9759C2.28149 13.874 5.94207 12.8033 7.65904 12.3326C8.03451 13.5165 8.52695 14.7544 9.12123 16.0062C8.51925 17.2766 8.01977 18.5341 7.64085 19.732C6.00369 19.2776 2.28149 18.0791 2.28149 15.9759ZM9.1037 4.50354C10.9735 3.45416 13.8747 6.00983 15.1159 7.16013C14.2444 8.06754 13.3831 9.1006 12.5603 10.2265C11.1494 10.3533 9.79875 10.5569 8.55709 10.8297C8.09125 9.02071 7.23592 5.55179 9.1037 4.50354ZM20.3793 11.5771C21.3365 11.6942 22.2536 11.85 23.1147 12.0406C22.8562 12.844 22.534 13.6841 22.1545 14.5453C21.6044 13.5333 21.0139 12.5416 20.3793 11.5771ZM16.0143 8.0481C16.6054 8.66897 17.1974 9.3623 17.7798 10.1145C16.5985 10.0603 15.4153 10.0601 14.234 10.1137C14.8169 9.36848 15.414 8.67618 16.0143 8.0481ZM9.8565 14.5444C9.48329 13.6862 9.16398 12.8424 8.90322 12.0275C9.75918 11.8418 10.672 11.69 11.623 11.5748C10.9866 12.5372 10.3971 13.5285 9.8565 14.5444ZM11.6503 20.4657C10.6679 20.3594 9.74126 20.2153 8.88556 20.0347C9.15044 19.2055 9.47678 18.3435 9.85796 17.4668C10.406 18.4933 11.0045 19.4942 11.6503 20.4657ZM16.0498 23.9915C15.4424 23.356 14.8365 22.6531 14.2448 21.8971C15.4328 21.9423 16.6231 21.9424 17.811 21.891C17.2268 22.6608 16.6369 23.3647 16.0498 23.9915ZM22.1667 17.4222C22.5677 18.3084 22.9057 19.1657 23.1742 19.9809C22.3043 20.1734 21.3652 20.3284 20.3757 20.4435C21.015 19.4607 21.6149 18.4536 22.1667 17.4222ZM18.7473 20.5941C16.9301 20.72 15.1016 20.7186 13.2838 20.6044C12.2509 19.1415 11.3314 17.603 10.5377 16.0058C11.3276 14.4119 12.2404 12.8764 13.2684 11.4158C15.0875 11.2825 16.9178 11.2821 18.7369 11.4166C19.7561 12.8771 20.6675 14.4086 21.4757 15.9881C20.6771 17.5812 19.7595 19.1198 18.7473 20.5941ZM22.8303 4.4666C24.7006 5.51254 23.8681 9.22726 23.4595 10.8426C22.2149 10.5641 20.8633 10.3569 19.4483 10.2281C18.6239 9.09004 17.7698 8.05518 16.9124 7.15949C18.1695 5.98441 20.9781 3.43089 22.8303 4.4666Z"
                fill="#53C1DE"
              />
            </svg>
            <h2>React.js</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <svg
              width="800px"
              height="800px"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0497 8.44062C22.6378 3.32607 19.2566 0 19.2566 0C19.7598 5.28738 13.813 6.53583 12.2189 10.1692C11.1312 12.6485 12.9638 14.8193 16.0475 17.5554C15.7749 16.9494 15.3544 16.3606 14.9288 15.7645C13.4769 13.7313 11.9645 11.6132 16.0497 8.44062Z"
                fill="#E76F00"
              />
              <path
                d="M17.1015 18.677C17.1015 18.677 19.0835 17.0779 17.5139 15.3008C12.1931 9.27186 23.3333 6.53583 23.3333 6.53583C16.5317 9.8125 17.5471 11.7574 19.2567 14.1202C21.0871 16.6538 17.1015 18.677 17.1015 18.677Z"
                fill="#E76F00"
              />
              <path
                d="M22.937 23.4456C29.0423 20.3258 26.2195 17.3278 24.2492 17.7317C23.7662 17.8305 23.5509 17.9162 23.5509 17.9162C23.5509 17.9162 23.7302 17.64 24.0726 17.5204C27.9705 16.1729 30.9682 21.4949 22.8143 23.6028C22.8143 23.6029 22.9088 23.5198 22.937 23.4456Z"
                fill="#5382A1"
              />
              <path
                d="M10.233 19.4969C6.41312 18.9953 12.3275 17.6139 12.3275 17.6139C12.3275 17.6139 10.0307 17.4616 7.20592 18.8043C3.86577 20.3932 15.4681 21.1158 21.474 19.5625C22.0984 19.1432 22.9614 18.7798 22.9614 18.7798C22.9614 18.7798 20.5037 19.2114 18.0561 19.4145C15.0612 19.6612 11.8459 19.7093 10.233 19.4969Z"
                fill="#5382A1"
              />
              <path
                d="M11.6864 22.4758C9.55624 22.2592 10.951 21.2439 10.951 21.2439C5.43898 23.0429 14.0178 25.083 21.7199 22.8682C20.9012 22.5844 20.3806 22.0653 20.3806 22.0653C16.6163 22.7781 14.441 22.7553 11.6864 22.4758Z"
                fill="#5382A1"
              />
              <path
                d="M12.6145 25.6991C10.486 25.4585 11.7295 24.7474 11.7295 24.7474C6.72594 26.1222 14.7729 28.9625 21.1433 26.2777C20.0999 25.8787 19.3528 25.4181 19.3528 25.4181C16.5111 25.9469 15.1931 25.9884 12.6145 25.6991Z"
                fill="#5382A1"
              />
              <path
                d="M25.9387 27.3388C25.9387 27.3388 26.8589 28.0844 24.9252 28.6612C21.2481 29.7566 9.62093 30.0874 6.39094 28.7049C5.22984 28.2082 7.40723 27.5189 8.09215 27.3742C8.80646 27.2219 9.21466 27.2503 9.21466 27.2503C7.9234 26.3558 0.868489 29.0067 5.63111 29.7659C18.6195 31.8372 29.3077 28.8331 25.9387 27.3388Z"
                fill="#5382A1"
              />
              <path
                d="M28 28.9679C27.7869 31.6947 18.7877 32.2683 12.9274 31.8994C9.10432 31.6583 8.33812 31.0558 8.32691 31.047C11.9859 31.6402 18.1549 31.7482 23.1568 30.8225C27.5903 30.0016 28 28.9679 28 28.9679Z"
                fill="#5382A1"
              />
            </svg>
            <h2>Java</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-left">
          <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      x="0"
      y="0"
      viewBox="0 0 48 48"
    >
      <path
        fill="#8bc34a"
        d="M43.982 23.635c.069-4.261-.891-9.328-2.891-15.273L39.523 3.7l-2.13 4.433a9.1 9.1 0 01-.38.698C33.514 5.827 28.974 4 24 4 12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20c0-.123-.016-.242-.018-.365z"
      ></path>
      <path
        fill="#fff"
        d="M39.385 32.558C36.262 36.86 30.734 37.091 25.531 37h-8.719c4.428-1.593 7.063-1.972 9.754-3.4 5.068-2.665 10.078-8.496 11.121-14.562-1.93 5.836-7.779 10.85-13.109 12.889-3.652 1.393-10.248 2.745-10.248 2.745l-.267-.145c-4.49-2.259-4.626-12.313 3.537-15.559 3.574-1.423 6.993-.641 10.854-1.593 4.122-1.012 8.89-4.208 10.83-8.375 2.172 6.667 4.786 17.106.101 23.558zm-23.717 5.887c-.282.35-.713.555-1.163.555-.823 0-1.495-.677-1.495-1.5s.677-1.5 1.495-1.5c.341 0 .677.118.941.336.64.519.74 1.469.222 2.109z"
      ></path>
    </svg>
            <h2>Spring</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-left">
            <svg
              viewBox="-8.78 0 70 70"
              xmlns="http://www.w3.org/2000/svg"
              {...props}
            >
              <path
                d="M22.065 69.955c-6.553-.472-13.029-2.121-17-4.33-2.263-1.257-3.986-2.803-4.663-4.18L0 60.625V9.21l.318-.646c1.423-2.89 5.965-5.494 12.304-7.056C14.774.976 17.881.447 20.415.18c2.588-.272 9.448-.23 12.03.073 6.86.806 12.699 2.611 16.297 5.038 1.387.936 2.811 2.433 3.294 3.464l.413.884-.035 25.63-.036 25.63-.332.675c-.182.371-.734 1.1-1.225 1.622-2.992 3.171-9.41 5.517-17.827 6.517-1.715.204-9.169.369-10.93.242zM34.14 47.927c-.025-.066-1.005-.938-2.177-1.94-1.172-1-2.181-1.866-2.243-1.924-.062-.057.155-.26.481-.452.327-.191.952-.724 1.39-1.183 1.28-1.342 1.884-3.001 1.884-5.174 0-2.138-.651-3.864-1.956-5.181-1.316-1.328-2.826-1.899-5.025-1.899-3.39 0-5.994 1.978-6.825 5.185-.286 1.104-.284 3.333.003 4.31.75 2.552 2.79 4.405 5.33 4.84.86.147.977.21 1.563.852.348.38 1.063 1.14 1.588 1.689l.955.996h2.539c1.396 0 2.518-.053 2.493-.12zm-8.707-7.109c-.61-.318-.842-.566-1.19-1.274-.27-.547-.316-.859-.319-2.152-.003-1.314.039-1.598.32-2.17.46-.933 1.094-1.375 2.074-1.446 1.364-.099 2.152.57 2.565 2.18.506 1.973-.05 4.071-1.265 4.767-.637.366-1.587.407-2.185.095zM14.18 44.481c2.662-.505 4.173-2.053 4.173-4.275 0-1.971-.976-3.12-3.672-4.323-1.543-.69-2.102-1.122-2.102-1.627 0-.42.53-.878 1.148-.993.603-.113 2.202.165 3.147.546l.792.32v-3.505l-.86-.19c-.53-.118-1.647-.189-2.921-.185-1.805 0-2.159.044-2.838.314-1.985.787-2.926 2.13-2.911 4.148.014 1.89 1.01 3.069 3.492 4.13 1.464.625 2.05 1.101 2.05 1.664 0 1.197-1.993 1.344-4.104.304l-1.154-.57c-.056-.029-.103.79-.103 1.819 0 1.862.002 1.871.34 2 1.27.483 4.076.698 5.523.423zm30.43-1.728v-1.58H39.8V30.311H35.537v14.022h9.074v-1.58zM29.764 15.048c4.235-.293 7.41-.848 10.202-1.782 2.783-.93 4.427-2.056 4.794-3.283.142-.473.132-.652-.066-1.17-.888-2.325-5.847-4.111-13.425-4.835-3.242-.31-9.137-.21-12.228.208-4.716.637-8.543 1.82-10.245 3.168-3.442 2.726.198 5.724 8.664 7.135 3.671.612 8.427.828 12.304.56z"
                fill="#00bcf2"
              />
            </svg>
            <h2>SQL</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-left">
            <svg
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              {...props}
            >
              <path
                d="M2.585 17.413a1.999 1.999 0 0 1 0-2.826L14.587 2.585c.78-.78 2.046-.78 2.826 0l12.002 12.002c.78.78.78 2.046 0 2.826L17.413 29.415c-.78.78-2.046.78-2.826 0L2.585 17.413Z"
                fill="#EE513B"
              />
              <path
                d="m12.149 5.062-1.215 1.215 3.139 3.139A2.126 2.126 0 0 0 15.25 12.3v7.679a2.126 2.126 0 1 0 1.718.097v-7.765l3 3a2.125 2.125 0 1 0 1.283-1.147l-3.221-3.223a2.125 2.125 0 0 0-2.66-2.66l-3.221-3.22Z"
                fill="#fff"
              />
            </svg>
            <h2>Git</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-right">
            <svg
              viewBox="0 0 256 256"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid"
              {...props}
            >
              <path
                d="M254.953 144.253c8.959-70.131-40.569-134.248-110.572-143.206C74.378-7.912 10.005 41.616 1.047 111.619c-8.959 70.003 40.569 134.248 110.572 143.334 70.131 8.959 134.248-40.569 143.334-110.7Z"
                fill="#FF6C37"
              />
              <path
                d="m174.2 82.184-54.007 54.007-15.229-15.23c53.11-53.11 58.358-48.503 69.236-38.777Z"
                fill="#FFF"
              />
              <path
                d="M120.193 137.47c-.384 0-.64-.128-.895-.384l-15.358-15.229a1.237 1.237 0 0 1 0-1.792c54.007-54.006 59.638-48.887 71.028-38.649.255.256.383.512.383.896s-.128.64-.383.896l-54.007 53.878c-.128.256-.512.384-.768.384Zm-13.437-16.509 13.437 13.438 52.087-52.087c-9.47-8.446-15.87-11.006-65.524 38.65Z"
                fill="#FF6C37"
              />
              <path
                d="m135.679 151.676-14.718-14.718 54.007-54.006c14.46 14.59-7.167 38.265-39.29 68.724Z"
                fill="#FFF"
              />
              <path
                d="M135.679 152.956c-.384 0-.64-.128-.896-.384l-14.718-14.718c-.256-.256-.256-.512-.256-.896s.128-.64.384-.895L174.2 82.056a1.237 1.237 0 0 1 1.791 0 15.58 15.58 0 0 1 4.991 11.902c-.256 14.206-16.38 32.25-44.28 58.614-.383.256-.767.384-1.023.384Zm-12.926-15.998c8.19 8.319 11.646 11.646 12.926 12.926 21.5-20.476 42.36-41.464 42.488-55.926.128-3.327-1.152-6.655-3.327-9.214l-52.087 52.214Z"
                fill="#FF6C37"
              />
              <path
                d="m105.22 121.345 10.878 10.878c.256.256.256.512 0 .768-.128.128-.128.128-.256.128l-22.524 4.863c-1.152.128-2.175-.64-2.431-1.791-.128-.64.128-1.28.512-1.664l13.053-13.054c.256-.256.64-.384.768-.128Z"
                fill="#FFF"
              />
              <path
                d="M92.934 139.262c-1.92 0-3.327-1.536-3.327-3.455 0-.896.384-1.792 1.024-2.432l13.053-13.054c.768-.64 1.792-.64 2.56 0l10.878 10.878c.768.64.768 1.792 0 2.56-.256.256-.512.384-.896.512l-22.524 4.863c-.256 0-.512.128-.768.128Zm11.902-16.51-12.542 12.543c-.256.256-.383.64-.128 1.024.128.383.512.511.896.383l21.116-4.607-9.342-9.342Z"
                fill="#FF6C37"
              />
              <path
                d="M202.739 52.238c-8.191-7.935-21.373-7.679-29.307.64-7.935 8.318-7.679 21.372.64 29.306A20.678 20.678 0 0 0 199.155 85l-14.59-14.59 18.174-18.172Z"
                fill="#FFF"
              />
              <path
                d="M188.405 89.223c-12.158 0-22.012-9.854-22.012-22.012 0-12.158 9.854-22.012 22.012-22.012 5.631 0 11.134 2.176 15.23 6.143.255.256.383.512.383.896s-.128.64-.384.895L186.357 70.41l13.566 13.566c.512.512.512 1.28 0 1.792l-.256.256c-3.327 2.047-7.295 3.199-11.262 3.199Zm0-41.337c-10.75 0-19.452 8.703-19.324 19.453 0 10.75 8.702 19.452 19.452 19.324 2.944 0 5.887-.64 8.575-2.047l-13.438-13.31c-.256-.256-.384-.512-.384-.896s.128-.64.384-.895l17.149-17.15c-3.456-2.943-7.807-4.479-12.414-4.479Z"
                fill="#FF6C37"
              />
              <path
                d="m203.122 52.622-.255-.256-18.301 18.044 14.461 14.462c1.408-.896 2.816-1.92 3.967-3.072a20.51 20.51 0 0 0 .128-29.178Z"
                fill="#FFF"
              />
              <path
                d="M199.155 86.28c-.384 0-.64-.128-.896-.384l-14.589-14.59c-.256-.256-.384-.512-.384-.896s.128-.64.384-.895l18.173-18.173a1.237 1.237 0 0 1 1.791 0l.384.256c8.575 8.574 8.575 22.396.128 31.098-1.28 1.28-2.687 2.432-4.223 3.328-.384.128-.64.256-.768.256Zm-12.798-15.87 12.926 12.926c1.024-.64 2.048-1.536 2.816-2.304 7.294-7.294 7.678-19.196.64-26.875L186.357 70.41Z"
                fill="#FF6C37"
              />
              <path
                d="M176.375 84.488a7.879 7.879 0 0 0-11.134 0l-48.247 48.247 8.063 8.063 51.062-44.792c3.328-2.816 3.584-7.807.768-11.134-.256-.128-.384-.256-.512-.384Z"
                fill="#FFF"
              />
              <path
                d="M124.929 142.077c-.384 0-.64-.128-.896-.383l-8.063-8.063a1.237 1.237 0 0 1 0-1.792l48.247-48.247a9.115 9.115 0 0 1 12.926 0 9.115 9.115 0 0 1 0 12.926l-.384.384-51.063 44.792c-.128.255-.384.383-.767.383Zm-6.143-9.342 6.27 6.271 50.167-44.024c2.816-2.304 3.072-6.527.768-9.342-2.303-2.816-6.526-3.072-9.342-.768-.128.128-.256.256-.512.384l-47.351 47.48Z"
                fill="#FF6C37"
              />
              <path
                d="M80.009 187.637c-.512.256-.768.768-.64 1.28l2.175 9.214c.512 1.28-.256 2.816-1.663 3.2-1.024.384-2.176 0-2.816-.768l-14.077-13.95 45.943-45.943 15.87.256 10.75 10.75c-2.56 2.175-18.045 17.149-55.542 35.961Z"
                fill="#FFF"
              />
              <path
                d="M78.985 202.61c-1.024 0-2.048-.383-2.688-1.151l-13.95-13.95c-.255-.256-.383-.512-.383-.896 0-.383.128-.64.384-.895l45.944-45.944c.256-.256.64-.384.895-.384l15.87.256c.383 0 .64.128.895.384l10.75 10.75c.256.256.384.64.384 1.024s-.128.64-.512.896l-.895.767c-13.566 11.902-31.995 23.804-54.902 35.194l2.175 9.086c.384 1.664-.384 3.456-1.92 4.352-.767.384-1.407.512-2.047.512Zm-14.078-15.997 13.182 13.054c.384.64 1.152.896 1.792.512.64-.384.896-1.152.512-1.792l-2.176-9.214c-.256-1.152.256-2.176 1.28-2.688 22.652-11.39 40.952-23.163 54.39-34.81l-9.47-9.47-14.718-.256-44.792 44.664Z"
                fill="#FF6C37"
              />
              <path
                d="m52.11 197.62 11.006-11.007 16.38 16.381-26.107-1.791c-1.151-.128-1.92-1.152-1.791-2.304 0-.512.128-1.024.512-1.28Z"
                fill="#FFF"
              />
              <path
                d="m79.497 204.146-26.236-1.791c-1.92-.128-3.199-1.792-3.071-3.712.128-.768.384-1.535 1.024-2.047L62.22 185.59a1.237 1.237 0 0 1 1.792 0l16.38 16.38c.385.385.512.897.257 1.408-.256.512-.64.768-1.152.768Zm-16.381-15.74-10.11 10.11c-.384.255-.384.895 0 1.151.127.128.255.256.511.256l22.652 1.536-13.053-13.054ZM104.452 146.557c-.768 0-1.28-.64-1.28-1.28 0-.384.128-.64.384-.896l12.414-12.414a1.237 1.237 0 0 1 1.792 0l8.062 8.063c.384.384.512.768.384 1.28-.128.384-.512.767-1.023.895l-20.477 4.352h-.256Zm12.414-11.902-8.446 8.446 13.821-2.943-5.375-5.503Z"
                fill="#FF6C37"
              />
              <path
                d="m124.8 140.926-14.077 3.071c-1.024.256-2.048-.384-2.303-1.408-.128-.64 0-1.28.511-1.791l7.807-7.807 8.063 7.935Z"
                fill="#FFF"
              />
              <path
                d="M110.467 145.277a3.168 3.168 0 0 1-3.2-3.2c0-.895.385-1.663.897-2.303l7.806-7.807a1.237 1.237 0 0 1 1.792 0l8.062 8.063c.384.384.512.768.384 1.28-.128.384-.512.767-1.023.895l-14.078 3.072h-.64Zm6.399-10.622-6.91 6.91c-.257.257-.257.512-.129.768s.384.384.768.384l11.774-2.56-5.503-5.502ZM203.25 64.907c-.256-.767-1.151-1.151-1.92-.895-.767.255-1.151 1.151-.895 1.92 0 .127.128.255.128.383.768 1.536.512 3.455-.512 4.863-.512.64-.384 1.536.128 2.048.64.512 1.536.384 2.048-.256 1.92-2.432 2.303-5.503 1.023-8.063Z"
                fill="#FF6C37"
              />
            </svg>
            <h2>Postman</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <svg
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              {...props}
            >
              <mask
                id="a"
                masktype="alpha"
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={100}
                height={100}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M70.912 99.317a6.223 6.223 0 0 0 4.96-.19l20.589-9.907A6.25 6.25 0 0 0 100 83.587V16.413a6.25 6.25 0 0 0-3.54-5.632L75.874.874a6.226 6.226 0 0 0-7.104 1.21L29.355 38.04 12.187 25.01a4.162 4.162 0 0 0-5.318.236l-5.506 5.009a4.168 4.168 0 0 0-.004 6.162L16.247 50 1.36 63.583a4.168 4.168 0 0 0 .004 6.162l5.506 5.01a4.162 4.162 0 0 0 5.318.236l17.168-13.032L68.77 97.917a6.217 6.217 0 0 0 2.143 1.4ZM75.015 27.3 45.11 50l29.906 22.701V27.3Z"
                  fill="#fff"
                />
              </mask>
              <g mask="url(#a)">
                <path
                  d="M96.461 10.796 75.857.876a6.23 6.23 0 0 0-7.107 1.207l-67.451 61.5a4.167 4.167 0 0 0 .004 6.162l5.51 5.009a4.167 4.167 0 0 0 5.32.236l81.228-61.62c2.725-2.067 6.639-.124 6.639 3.297v-.24a6.25 6.25 0 0 0-3.539-5.63Z"
                  fill="#0065A9"
                />
                <g filter="url(#b)">
                  <path
                    d="m96.461 89.204-20.604 9.92a6.229 6.229 0 0 1-7.107-1.207l-67.451-61.5a4.167 4.167 0 0 1 .004-6.162l5.51-5.009a4.167 4.167 0 0 1 5.32-.236l81.228 61.62c2.725 2.067 6.639.124 6.639-3.297v.24a6.25 6.25 0 0 1-3.539 5.63Z"
                    fill="#007ACC"
                  />
                </g>
                <g filter="url(#c)">
                  <path
                    d="M75.858 99.126a6.232 6.232 0 0 1-7.108-1.21c2.306 2.307 6.25.674 6.25-2.588V4.672c0-3.262-3.944-4.895-6.25-2.589a6.232 6.232 0 0 1 7.108-1.21l20.6 9.908A6.25 6.25 0 0 1 100 16.413v67.174a6.25 6.25 0 0 1-3.541 5.633l-20.601 9.906Z"
                    fill="#1F9CF0"
                  />
                </g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M70.851 99.317a6.224 6.224 0 0 0 4.96-.19L96.4 89.22a6.25 6.25 0 0 0 3.54-5.633V16.413a6.25 6.25 0 0 0-3.54-5.632L75.812.874a6.226 6.226 0 0 0-7.104 1.21L29.294 38.04 12.126 25.01a4.162 4.162 0 0 0-5.317.236l-5.507 5.009a4.168 4.168 0 0 0-.004 6.162L16.186 50 1.298 63.583a4.168 4.168 0 0 0 .004 6.162l5.507 5.009a4.162 4.162 0 0 0 5.317.236L29.294 61.96l39.414 35.958a6.218 6.218 0 0 0 2.143 1.4ZM74.954 27.3 45.048 50l29.906 22.701V27.3Z"
                  fill="url(#d)"
                  style={{
                    mixBlendMode: "overlay",
                  }}
                  opacity={0.25}
                />
              </g>
              <defs>
                <filter
                  id="b"
                  x={-8.394}
                  y={15.829}
                  width={116.727}
                  height={92.246}
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation={4.167} />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                  <feBlend
                    mode="overlay"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
                <filter
                  id="c"
                  x={60.417}
                  y={-8.076}
                  width={47.917}
                  height={116.151}
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation={4.167} />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                  <feBlend
                    mode="overlay"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
                <linearGradient
                  id="d"
                  x1={49.939}
                  y1={0.258}
                  x2={49.939}
                  y2={99.742}
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#fff" />
                  <stop offset={1} stopColor="#fff" stopOpacity={0} />
                </linearGradient>
              </defs>
            </svg>

            <h2>VS Code</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="400"
              height="291"
              x="0"
              y="0"
              version="1.1"
              viewBox="0 0 396 288"
              xmlSpace="preserve"
            >
              <path
                fill="#FBBD16"
                d="M208.096 234.496L208.096 158.167 222.729 240.603 246.553 252.477 261.867 183.949 261.867 258.923 288.753 272.151 288.753 145.616 247.914 126.278 234.982 186.663 221.937 113.84 181.323 94.391 181.323 221.04z"
              ></path>
              <path
                fill="#452E7F"
                d="M292.496 145.583L335.152 123.418 335.152 215.238 394.142 184.709 394.369 219.31 292.611 272.796z"
              ></path>
              <path
                fill="#962444"
                d="M275.298 12.158l-30.163 26.669s58.851 30.25 66 33.825c7.15 3.574 17.325 10.449 6.325 20.625-11 10.175-23.1 8.8-31.35 4.675s-69.3-34.925-69.3-34.925l-31.074 26.399s59.949 30.525 69.85 35.75c9.9 5.226 46.75 18.15 81.675-9.075 34.925-27.225 29.976-37.125 29.976-39.05s-.825-12.1-6.875-18.425c-6.051-6.325-23.65-15.4-31.075-19.25s-53.989-27.218-53.989-27.218z"
              ></path>
              <path
                fill="#4A2469"
                d="M50.154 100.832v18.721c0 2.123-.057 3.614-.17 4.473-.113.859-.448 1.741-1.006 2.646-.557.906-1.29 1.594-2.202 2.06-.911.468-1.985.7-3.222.7-1.369 0-2.577-.275-3.626-.829-1.048-.555-1.831-1.275-2.352-2.163-.519-.889-.825-1.825-.92-2.812s-.141-3.061-.141-6.221v-16.575h5.968v21.002c0 1.223.055 2.005.162 2.344.107.341.326.511.653.511.374 0 .615-.188.725-.563.107-.375.161-1.26.161-2.655v-20.639h5.97zM69.866 100.832v28.007h-5.237l-3.104-12.732v12.732h-4.98v-28.007h5.001l3.34 12.611v-12.611h4.98zM82.308 100.832v28.007h-5.969v-28.007h5.969zM86.875 100.832h12.017v5.612h-4.929v5.297h4.39v5.337h-4.39v11.761h-7.088v-28.007zM110.365 100.832v28.007h-5.969v-28.007h5.969zM116.83 100.832h9.942v5.612h-3.974v5.297h3.717v5.337h-3.717v6.148h4.368v5.612H116.83v-28.006zM132.965 100.832h4.47c2.886 0 4.836.161 5.854.483 1.018.324 1.791.854 2.32 1.592s.86 1.56.994 2.466c.132.905.198 2.684.198 5.336v9.809c0 2.516-.097 4.195-.291 5.043-.194.849-.533 1.512-1.015 1.99-.482.479-1.079.813-1.788 1.004-.709.189-1.778.284-3.207.284h-7.535v-28.007zm5.97 4.782v18.442c.864 0 1.397-.211 1.598-.633.199-.421.299-1.566.299-3.437v-10.892c0-1.271-.033-2.084-.1-2.441s-.219-.621-.456-.789c-.238-.165-.686-.25-1.341-.25zM20.979 146.977v28.009h-5.217l-.009-18.909-2.067 18.909H9.969l-2.186-18.494-.008 18.494H2.557v-28.009h7.725c.228 1.688.464 3.676.709 5.959l.847 7.119 1.359-13.078h7.782zM41.391 163.386c0 2.813-.054 4.805-.163 5.976a7.598 7.598 0 01-1.021 3.207 5.835 5.835 0 01-2.318 2.231c-.975.519-2.109.778-3.405.778-1.229 0-2.333-.245-3.312-.736-.979-.489-1.766-1.223-2.362-2.204a7.495 7.495 0 01-1.063-3.199c-.113-1.154-.17-3.171-.17-6.053v-4.791c0-2.813.054-4.804.162-5.974a7.622 7.622 0 011.022-3.209 5.845 5.845 0 012.318-2.23c.975-.52 2.109-.778 3.404-.778 1.23 0 2.335.246 3.313.735.978.49 1.765 1.226 2.361 2.205.596.979.95 2.046 1.063 3.199.113 1.152.17 3.17.17 6.052v4.791zm-5.969-9.197c0-1.302-.06-2.135-.178-2.497-.119-.363-.363-.545-.732-.545-.313 0-.552.147-.719.44-.166.294-.249 1.161-.249 2.602v13.066c0 1.625.055 2.627.163 3.007.109.382.363.572.762.572.408 0 .669-.221.783-.658.112-.437.17-1.479.17-3.128v-12.859zM47.959 146.977h4.47c2.886 0 4.837.162 5.854.484 1.018.324 1.791.854 2.32 1.593a5.55 5.55 0 01.993 2.464c.134.906.199 2.685.199 5.337v9.809c0 2.516-.097 4.196-.291 5.044-.193.848-.532 1.509-1.015 1.988-.482.479-1.078.813-1.788 1.003-.709.19-1.778.287-3.207.287h-7.535v-28.009zm5.97 4.783v18.442c.865 0 1.397-.211 1.597-.633.2-.42.3-1.566.3-3.438V155.24c0-1.27-.033-2.083-.1-2.441s-.218-.62-.457-.788c-.238-.167-.684-.251-1.34-.251zM68.369 146.977h12.072v5.613h-4.824v5.297h4.512v5.337h-4.512v6.147h5.303v5.614H68.369v-28.008zM92.532 146.977v22.395h4.715v5.614H84.795v-28.009h7.737zM106.169 146.977v28.009h-5.97v-28.009h5.97zM126.245 146.977v28.009h-5.238l-3.103-12.733v12.733h-4.981v-28.009h5.001l3.341 12.612v-12.612h4.98zM146.705 157.294h-5.969v-2.538c0-1.6-.058-2.602-.17-3.005-.113-.402-.381-.604-.804-.604-.366 0-.615.173-.747.519s-.197 1.233-.197 2.662v13.43c0 1.256.065 2.083.196 2.479.132.397.395.599.789.599.431 0 .724-.226.877-.675.155-.45.232-1.325.232-2.629v-3.319h-1.186v-4.25h6.978v15.023h-3.765l-.555-2.007c-.406.865-.917 1.515-1.535 1.947-.617.435-1.347.652-2.186.652-1 0-1.938-.296-2.81-.893-.872-.593-1.535-1.326-1.987-2.203a8.049 8.049 0 01-.85-2.758c-.112-.963-.17-2.408-.17-4.333v-8.319c0-2.673.118-4.615.354-5.826s.914-2.321 2.034-3.329c1.119-1.009 2.566-1.514 4.342-1.514 1.748 0 3.196.438 4.349 1.313 1.152.878 1.903 1.918 2.252 3.121.351 1.206.525 2.954.525 5.247v1.21zM11.112 192.022v22.395h4.833v5.613H3.177v-28.008h7.935zM31.58 191.705l3.424 28.009H28.9l-.318-5.04h-2.128l-.349 5.04h-6.183l3.048-28.009h8.61zm-3.151 18.008c-.297-3.168-.6-7.089-.907-11.767-.593 5.369-.968 9.29-1.127 11.767h2.034zM53.164 192.022v28.008h-5.983l-3.545-12.734v12.734h-5.69v-28.008h5.712l3.817 12.61v-12.61h5.689zM73.392 202.34h-6.785v-2.54c0-1.599-.064-2.599-.193-3.005-.128-.402-.434-.603-.913-.603-.417 0-.699.173-.85.519-.149.347-.225 1.233-.225 2.661v13.431c0 1.255.075 2.083.225 2.479.147.397.446.599.895.599.49 0 .823-.226 1-.675.175-.45.264-1.324.264-2.63v-3.317h-1.35v-4.249h7.932v15.021h-4.279l-.631-2.007c-.461.865-1.043 1.515-1.744 1.947-.704.435-1.532.652-2.487.652a6.085 6.085 0 01-3.192-.893c-.992-.593-1.745-1.326-2.26-2.203s-.837-1.796-.965-2.757c-.13-.964-.193-2.41-.193-4.334v-8.318c0-2.674.133-4.616.401-5.827.269-1.21 1.04-2.32 2.313-3.33 1.272-1.009 2.917-1.512 4.937-1.512 1.986 0 3.636.437 4.945 1.314 1.311.874 2.163 1.914 2.561 3.12.397 1.203.596 2.952.596 5.246v1.211zM92.757 192.022v18.721c0 2.122-.063 3.614-.186 4.472-.124.859-.49 1.741-1.099 2.647a5.832 5.832 0 01-2.405 2.059c-.997.468-2.17.702-3.521.702-1.496 0-2.817-.276-3.962-.83-1.146-.553-2.002-1.275-2.568-2.164-.569-.888-.904-1.823-1.008-2.812-.103-.986-.153-3.06-.153-6.22v-16.575h6.522v21.001c0 1.223.058 2.006.178 2.344.116.342.354.513.713.513.409 0 .673-.188.789-.564.117-.372.178-1.26.178-2.655v-20.638h6.522zM108.235 192.022l3.424 28.008h-6.104l-.319-5.04h-2.128l-.349 5.04h-6.182l3.048-28.008h8.61zm-3.15 18.006c-.298-3.167-.6-7.089-.908-11.765-.593 5.368-.969 9.29-1.126 11.765h2.034zM130.512 202.34h-6.65v-2.54c0-1.599-.063-2.599-.188-3.005-.126-.402-.423-.603-.896-.603-.407 0-.686.173-.832.519-.146.347-.22 1.233-.22 2.661v13.431c0 1.255.073 2.083.219 2.479.146.397.438.599.878.599.48 0 .807-.226.979-.675.173-.45.259-1.324.259-2.63v-3.317h-1.321v-4.249h7.773v15.021h-4.194l-.617-2.007c-.452.865-1.022 1.515-1.711 1.947-.688.435-1.5.652-2.435.652a5.87 5.87 0 01-3.129-.893c-.974-.593-1.712-1.326-2.216-2.203a7.413 7.413 0 01-.946-2.757c-.125-.964-.188-2.41-.188-4.334v-8.318c0-2.674.132-4.616.396-5.827.262-1.21 1.017-2.32 2.264-3.33 1.247-1.009 2.86-1.512 4.838-1.512 1.947 0 3.562.437 4.846 1.314 1.284.874 2.12 1.914 2.51 3.12.39 1.203.584 2.952.584 5.246v1.211zM134.736 192.022h12.071v5.612h-4.823v5.299h4.512v5.336h-4.512v6.147h5.303v5.613h-12.551v-28.007z"
              ></path>
              <path
                fill="#6D6E71"
                d="M393.104 167.064c0 4.471-3.509 7.979-8.076 7.979-4.519 0-8.123-3.509-8.123-7.979 0-4.375 3.604-7.884 8.123-7.884 4.568.001 8.076 3.509 8.076 7.884zm-14.18 0c0 3.509 2.596 6.298 6.153 6.298 3.461 0 6.009-2.789 6.009-6.25 0-3.51-2.548-6.346-6.058-6.346-3.508.001-6.104 2.837-6.104 6.298zm4.855 4.134h-1.827v-7.883c.722-.146 1.731-.241 3.029-.241 1.489 0 2.163.241 2.739.577.433.336.769.961.769 1.73 0 .864-.672 1.538-1.634 1.827v.096c.77.289 1.202.864 1.442 1.923.24 1.202.385 1.683.576 1.971h-1.97c-.241-.288-.385-1.01-.626-1.923-.144-.865-.625-1.25-1.635-1.25h-.864v3.173zm.048-4.47h.865c1.01 0 1.827-.336 1.827-1.153 0-.721-.528-1.202-1.683-1.202-.481 0-.817.048-1.01.097v2.258z"
              ></path>
              <g fill="#4A2469">
                <path d="M156.248 210.816h-3.273v-1.182h7.967v1.182h-3.289v9.577h-1.404v-9.577zM171.209 215.668c-.08-1.5-.176-3.303-.159-4.645h-.049a64.925 64.925 0 01-1.355 4.086l-1.9 5.221h-1.053l-1.741-5.124c-.511-1.517-.941-2.906-1.245-4.183h-.032c-.03 1.342-.11 3.145-.207 4.758l-.288 4.612h-1.324l.75-10.759h1.772l1.835 5.204c.448 1.323.814 2.505 1.086 3.623h.048c.271-1.085.654-2.267 1.134-3.623l1.916-5.204h1.771l.671 10.759h-1.356l-.274-4.725z"></path>
              </g>
            </svg>

            <h2>UML</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <svg
              className="svg-restApi"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 25 25"
            >
              <g fill="#fff">
                <path d="M5.93 13.21l.738-2.837h.063l.728 2.838H5.93zM8.172 16H9.66l-2.1-7H5.93L3.83 16h1.378l.446-1.712h2.081L8.172 16zM10.539 9v7h1.378v-2.222h1.115c1.509 0 2.47-.926 2.47-2.382C15.502 9.926 14.57 9 13.1 9H10.54zm1.378 1.13h.834c.902 0 1.353.417 1.353 1.257 0 .844-.45 1.256-1.353 1.256h-.834V10.13zM21.168 16v-1.184h-1.451v-4.632h1.45V9H16.89v1.184h1.45v4.632h-1.45V16h4.279z"></path>
              </g>
            </svg>

            <h2>Rest API</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 32 32"
              preserveAspectRatio="xMidYMid"
              fill="#8cc84b"
            >
              <path d="M14.656.427c.8-.453 1.82-.455 2.6 0L29.2 7.16c.747.42 1.247 1.253 1.24 2.114v13.5c.005.897-.544 1.748-1.332 2.16l-11.88 6.702a2.6 2.6 0 0 1-2.639-.073l-3.565-2.06c-.243-.145-.516-.26-.688-.495.152-.204.422-.23.642-.32.496-.158.95-.4 1.406-.656.115-.08.256-.05.366.022l3.04 1.758c.217.125.437-.04.623-.145l11.665-6.583c.144-.07.224-.222.212-.38V9.334c.016-.18-.087-.344-.25-.417L16.19 2.244a.41.41 0 0 0-.465-.001L3.892 8.93c-.16.073-.27.235-.25.415v13.37c-.014.158.07.307.215.375l3.162 1.785c.594.32 1.323.5 1.977.265a1.5 1.5 0 0 0 .971-1.409l.003-13.29c-.014-.197.172-.36.363-.34h1.52c.2-.005.357.207.33.405L12.18 23.88c.001 1.188-.487 2.48-1.586 3.063-1.354.7-3.028.553-4.366-.12l-3.4-1.88c-.8-.4-1.337-1.264-1.332-2.16v-13.5a2.46 2.46 0 0 1 1.282-2.141L14.656.427zM18.1 9.785c1.727-.1 3.576-.066 5.13.785 1.203.652 1.87 2.02 1.892 3.358-.034.18-.222.28-.394.267-.5-.001-1.002.007-1.504-.003-.213.008-.336-.188-.363-.376-.144-.64-.493-1.273-1.095-1.582-.924-.463-1.996-.44-3.004-.43-.736.04-1.527.103-2.15.535-.48.328-.624 1-.453 1.522.16.383.603.506.964.62 2.082.544 4.287.5 6.33 1.207.845.292 1.672.86 1.962 1.745.378 1.186.213 2.604-.63 3.556-.684.784-1.68 1.2-2.675 1.442-1.323.295-2.695.302-4.038.17-1.263-.144-2.577-.476-3.552-1.336-.834-.724-1.24-1.852-1.2-2.94.01-.184.193-.312.37-.297h1.5c.202-.014.35.16.36.35.093.6.322 1.25.854 1.6 1.026.662 2.313.616 3.487.635.973-.043 2.065-.056 2.86-.7.42-.367.543-.98.43-1.508-.123-.446-.6-.653-1-.8-2.055-.65-4.285-.414-6.32-1.15-.826-.292-1.625-.844-1.942-1.693-.443-1.2-.24-2.687.693-3.607.9-.915 2.22-1.268 3.47-1.394z" />
            </svg>
            <h2>Node.js</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="64"
              viewBox="0 0 32 32"
              width="64"
            >
              <path
                d="M19.62 11.558l-3.203 2.98-2.972-5.995 1.538-3.448c.4-.7 1.024-.692 1.414 0z"
                fill="#ffa000"
              />
              <path
                d="M13.445 8.543l2.972 5.995-11.97 11.135z"
                fill="#f57f17"
              />
              <path
                d="M23.123 7.003c.572-.55 1.164-.362 1.315.417l3.116 18.105-10.328 6.2c-.36.2-1.32.286-1.32.286s-.874-.104-1.207-.3L4.447 25.673z"
                fill="#ffca28"
              />
              <path
                d="M13.445 8.543l-8.997 17.13L8.455.638c.148-.78.592-.855.988-.167z"
                fill="#ffa000"
              />
            </svg>
            <h2>Firebase</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 54 33"
            >
              <g clipPath="url(#prefix__clip0)">
                <path
                  fill="#38bdf8"
                  fillRule="evenodd"
                  d="M27 0c-7.2 0-11.7 3.6-13.5 10.8 2.7-3.6 5.85-4.95 9.45-4.05 2.054.513 3.522 2.004 5.147 3.653C30.744 13.09 33.808 16.2 40.5 16.2c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C36.756 3.11 33.692 0 27 0zM13.5 16.2C6.3 16.2 1.8 19.8 0 27c2.7-3.6 5.85-4.95 9.45-4.05 2.054.514 3.522 2.004 5.147 3.653C17.244 29.29 20.308 32.4 27 32.4c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C23.256 19.31 20.192 16.2 13.5 16.2z"
                  clipRule="evenodd"
                />
              </g>
              <defs>
                <clipPath id="prefix__clip0">
                  <path fill="#fff" d="M0 0h54v32.4H0z" />
                </clipPath>
              </defs>
            </svg>
            <h2>Tailwind CSS</h2>
          </StyledSingleSkill>

          <StyledSingleSkill data-aos="fade-right">
            <SiTypescript color="#3178C6" />
            <h2>TypeScript</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiVuedotjs color="#4FC08D" />
            <h2>Vue.js</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiNuxtdotjs color="#00DC82" />
            <h2>Nuxt</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiAngular color="#DD0031" />
            <h2>Angular</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiReact color="#61DAFB" />
            <h2>React Native</h2>
          </StyledSingleSkill>
          {/* Logo monochrome : herite de la couleur du texte pour rester lisible en clair comme en sombre. */}
          <StyledSingleSkill data-aos="fade-left">
            <SiExpress />
            <h2>Express.js</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiMongodb color="#47A248" />
            <h2>MongoDB</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiPostgresql color="#4169E1" />
            <h2>PostgreSQL</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiDocker color="#2496ED" />
            <h2>Docker</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiNginx color="#009639" />
            <h2>Nginx</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiGithubactions color="#2088FF" />
            <h2>GitHub Actions</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiLinux />
            <h2>Linux</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <SiGrafana color="#F46800" />
            <h2>Grafana / Loki</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <SiPrometheus color="#E6522C" />
            <h2>Prometheus</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-right">
            <TbTestPipe color="#2EAD33" />
            <h2>Playwright</h2>
          </StyledSingleSkill>
          <StyledSingleSkill data-aos="fade-left">
            <TbFlask color="#6E9F18" />
            <h2>Vitest</h2>
          </StyledSingleSkill>
        </StyledSkillsItems>
      </StyledSkillsSection>

      <hr data-aos="flip-left" />
    </>
  );
};
